import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios'

class AddCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amphoes: [],
      changwats: []
    }
    // this.handleSubmitAuto = this.handleSubmitAuto.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  componentDidMount() {
    let getChangwatsPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/changwats.json',
    )
    let getAmphoesPromise = axios.get(
      'https://raw.githubusercontent.com/ignitry/thai-tambons/master/dist/amphoes.json',
    )
    Promise.all([getChangwatsPromise, getAmphoesPromise]).then((data) => {
      this.setState({
        ...this.state,
        amphoes: Object.values(data[1]['data']),
        changwats: Object.values(data[0]['data']),
      })
    })
  }
  HandleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
    console.log(this.state)
  }
  handleSubmit = (e) => {
    e.preventDefault()
    console.log(this.state)
    console.log('Submitted')
    //     let c = axios.get(
    //   'https://backend1.riceinspections.com/testC',
    //   {
    //     data: {
    //       surveyLocateName : this.state.surveyLocateName,
    //       godown : this.state.godown,
    //       surveyDistrict : this.state.surveyDistrict , 
    //       surveyProvince : this.state.surveyProvince
    //     }
    //   })
    // .then(() => {
    //   this.setState({
    //     ...this.state,
    //     isSurveyTHComplete: 'complete'
    //   })

    let c = axios.post(
      'https://backend1.riceinspections.com/testBG',
      {
        data: this.state
      }
    ).then(res => {
      console.log(res);
      this.props.history.push('/adminsys')
    })
  }

  renderAmphoes(amphoes) {
    console.log(amphoes)
    if (amphoes.length > 0) {
      return (amphoes.map((amphoesData) => {
        // console.log(amphoesData['name'])
        return <option value={amphoesData['name']['th']}>{amphoesData['name']['th']}</option>
      }))
    }
  }
  renderChangwat(changwat) {
    console.log(changwat)

    if (changwat.length > 0) {
      return (changwat.map((changwatData) => {
        return <option value={changwatData['name']['th']}>{changwatData['name']['th']}</option>
      }))
    }
  }

  render() {
    return (
      <Container>
        {/* {this.handleSubmitAuto()} */}
        <form onSubmit={this.handleSubmit}>
          <Link to="AdminSys">back</Link>
          <h1 id="label1">Add Survey</h1>
          <label id="surveyLocateName">ชื่อสถานที่ภาษาไทย</label>
          <input type="text" id="surveyLocateName" className="inputText" placeholder="ชื่อสถานที่ภาษาไทย" onChange={this.HandleChange}></input>
          <label id="godown">ชื่อสถานที่ภาษาอังกฤษ</label>
          <input type="text" id="godown" className="inputText" placeholder="ชื่อสถานที่ภาษาอังกฤษ" onChange={this.HandleChange}></input>


          {/* <label id="surveyDistrict">อำเภอ</label>
          <select type="text" id="surveyDistrict" className="inputText" placeholder="อำเภอ" onChange={this.HandleChange}>
            {this.renderAmphoes(this.state.amphoes)}
          </select> */}


          <label id="surveyDistrict">อำเภอ</label>
          <input type="text" id="surveyDistrict" className="inputText" onChange={this.HandleChange} list="brow" />
          <datalist id="brow">
            {this.renderAmphoes(this.state.amphoes)}
          </datalist>

          <label id="surveyProvince">จังหวัด</label>
          <input type="text" id="surveyProvince" className="inputText" onChange={this.HandleChange} list="changwat" />
          <datalist id="changwat">
            {this.renderChangwat(this.state.changwats)}
          </datalist>
          <Button variant="outline-success" id="addOffice" type="submit">Add</Button>
          <Button variant="danger" id="addOffice" onClick={this.props.history.goBack}>cancel</Button>
        </form>

      </Container>
    )
  }
}

export default AddCompany;
